import { css } from 'aphrodite';
import * as React from 'react';
import { forwardRef } from 'react';
import { InputGroupAddon, InputGroupTextarea, InputGroupV2 } from '../../InputGroup';
import { styleSheet } from './styles';

// Parts rather than slot props, as PromptInput is: designs mount components through x-import, where elements can
// only arrive as children. None of them import Pill or anything data-bound, so the box stays importable from
// plugin-v2 (Pill reaches MobX through the legacy Button).

export const AIPromptBox = ({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) => (
	<InputGroupV2 styles={[styleSheet.group, ...styles]} {...props} />
);

export const AIPromptBoxToolbar = ({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) => (
	<InputGroupAddon align='blockStart' styles={[styleSheet.toolbar, ...styles]} {...props} />
);

export const AIPromptBoxToolbarEnd = ({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) => (
	<div className={css(styleSheet.toolbarEnd, ...styles)} {...props} />
);

export const AIPromptBoxTextarea = forwardRef<HTMLTextAreaElement, AphroditeStyled<React.ComponentProps<'textarea'>>>(
	(props, ref) => <InputGroupTextarea ref={ref} {...props} />
);
AIPromptBoxTextarea.displayName = 'AIPromptBoxTextarea';

export const AIPromptBoxFooter = (props: AphroditeStyled<React.ComponentProps<'div'>>) => (
	<InputGroupAddon align='blockEnd' {...props} />
);

export const AIPromptBoxCredit = ({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) => (
	<div className={css(styleSheet.credit, ...styles)} {...props} />
);
